<template>
    <router-view name='main'></router-view>

  <!-- <v-app>
      <v-content>
          <v-container class="fill-height" fluid>
          </v-container>
      </v-content>
  </v-app> -->
</template>

<script>
export default {
  name: 'App',
  data: () => ({
  }),
};
</script>
